export default {
  cms_pages: [],
  cms_page: {
    card_link: {}
  },
  pagination: {},
};
